<template>
  <v-list-tile ripple router :to="{name: item.link}" :active-class="textColor" class="curved-item">
    <v-list-tile-action>
      <v-icon :color="item.color" v-html="item.icon">item.icon</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title v-text="item.title"></v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    item: Object
  },
  computed: {
    textColor() {
      var colorArray = this.item.color.split(" ");
      return `${colorArray[0]}--text text--darken-3 ${colorArray[0]} lighten-5`;
    }
  }
};
</script>

<style>
.curved-item {
  width: 85%;
}
.curved-item .v-list__tile {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  transition: 0.3s !important;
}
</style>
